// constants
import { EmployeeActionTypes } from './constants';
import { Employee as EmployeeDataType } from 'src/types/employee';

export type EmployeeActionType = {
    type:
        | EmployeeActionTypes.API_RESPONSE_SUCCESS
        | EmployeeActionTypes.API_RESPONSE_ERROR
        | EmployeeActionTypes.GET_EMPLOYEES
        | EmployeeActionTypes.ADD_EMPLOYEE
        | EmployeeActionTypes.EDIT_EMPLOYEE
        | EmployeeActionTypes.GET_EMPLOYEE
        | EmployeeActionTypes.RESET
        | EmployeeActionTypes.RESET_SUCCESS
        | EmployeeActionTypes.RESET_ERROR;
    payload: {} | string;
};

// common success
export const employeeApiResponseSuccess = (
    actionType: string,
    data: EmployeeDataType | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): EmployeeActionType => ({
    type: EmployeeActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data, message, code, error, success },
});
// common error
export const employeeApiResponseError = (
    actionType: string,
    data: EmployeeDataType | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): EmployeeActionType => ({
    type: EmployeeActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, data, message, code, error, success },
});

export const addEmployee = (params: any): EmployeeActionType => ({
    type: EmployeeActionTypes.ADD_EMPLOYEE,
    payload: params,
});

export const editEmployee = (params: any): EmployeeActionType => ({
    type: EmployeeActionTypes.EDIT_EMPLOYEE,
    payload: params,
});

export const getEmployee = (params: any): EmployeeActionType => ({
    type: EmployeeActionTypes.GET_EMPLOYEE,
    payload: params,
});

export const getEmployees = (params: any): EmployeeActionType => ({
    type: EmployeeActionTypes.GET_EMPLOYEES,
    payload: params,
});

export const resetEmployee = (): EmployeeActionType => ({
    type: EmployeeActionTypes.RESET,
    payload: {},
});

export const resetEmployeeSuccess = (): EmployeeActionType => ({
    type: EmployeeActionTypes.RESET_SUCCESS,
    payload: {},
});
export const resetEmployeeError = (): EmployeeActionType => ({
    type: EmployeeActionTypes.RESET_ERROR,
    payload: {},
});
